import { word } from "@modules/core/utils/i18n"
import { HUText } from "@modules/ui/components/huText"
import { capitalizeAndLowercase } from "@modules/utils/stringUtils"
import { useTheme } from "styled-components"

export type HuBioCardProps = {
  description?: string
  job?: string
  category?: string
  age?: number
  height?: number
  weight?: number
} & React.HTMLAttributes<HTMLDivElement>

export const HuBioCard: React.FC<HuBioCardProps> = ({
  description = "",
  job = "",
  category = "",
  age = null,
  height = null,
  weight = null,
  ...props
}) => {
  const theme = useTheme()

  return (
    <div className="flex flex-column border-round-3xl bg-gradient-forestGreen overflow-hidden gap-4" {...props}>
      <HUText fontStyle="BM" color={theme.mainWhite} className="text-center">
        {word("huBioCard.bio")}
      </HUText>

      <div className="flex flex-column">
        <HUText className="uppercase" fontStyle="BS" color={theme.mainWhite}>
          {word("huBioCard.description")}
        </HUText>
        <HUText fontStyle="BS" color={theme.mainWhite}>
          {description ?? "--"}
        </HUText>
      </div>

      <div className="flex justify-content-between">
        <div className="flex flex-column w-6">
          <HUText className="uppercase" fontStyle="BS" color={theme.mainWhite}>
            {word("huBioCard.job")}
          </HUText>
          <HUText fontStyle="TS" color={theme.mainWhite}>
            {job ?? "--"}
          </HUText>
        </div>
        <div className="flex flex-column align-items-end">
          <HUText className="uppercase" fontStyle="BS" color={theme.mainWhite}>
            {word("huBioCard.category")}
          </HUText>
          <HUText fontStyle="TS" color={theme.mainWhite}>
            {category ? capitalizeAndLowercase(category) : "--"}
          </HUText>
        </div>
      </div>

      <div className="flex justify-content-between">
        <div className="flex flex-column">
          <HUText className="uppercase" fontStyle="BS" color={theme.mainWhite}>
            {word("huBioCard.age")}
          </HUText>
          <HUText fontStyle="TS" color={theme.mainWhite}>
            {age && age !== 0 ? age : "--"}
          </HUText>
        </div>
        <div className="flex flex-column align-items-center">
          <HUText className="uppercase" fontStyle="BS" color={theme.mainWhite}>
            {word("huBioCard.height")}
          </HUText>
          <HUText fontStyle="TS" color={theme.mainWhite}>
            {height ? `${height} cm` : "--"}
          </HUText>
        </div>
        <div className="flex flex-column align-items-end">
          <HUText className="uppercase" fontStyle="BS" color={theme.mainWhite}>
            {word("huBioCard.weight")}
          </HUText>
          <HUText fontStyle="TS" color={theme.mainWhite}>
            {weight ? `${weight} kg` : "--"}
          </HUText>
        </div>
      </div>
    </div>
  )
}
